import React from 'react';
import History from "./history/history";
import CenteredPageContainer from "../../common/centeredcontainer/centered-page-container";
import Values from "./values/values";
import DayGlance from "./dayglance/day-glance";
import OwnerWord from "./owner-word/owner-word";
import FooterXsci from "../../common/footer/footer-xsci";
import NavBar from "../../v2/layout/navigation/navBar";
import HeroBanner from "../../v2/layout/banner/HeroBanner";

const AboutUs = () => {

    const title = "À Propos de la Garderie La Belle Étoile"
    const subTitle = "Un milieu familial chaleureux et personnalisé à La Prairie"


    return (
        <>
            <NavBar/>
            <HeroBanner
                title={title}
                subTitle={subTitle}
                imageUrl = {"images/about/banner.jpg"}
                hideCta={false}
            />
            <CenteredPageContainer component={() => (
                <>
                    <History/>
                    <Values/>
                    <DayGlance/>
                    <OwnerWord/>
                </>
            )} />
            <FooterXsci/>
        </>
    );
};

export default AboutUs;
